import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'pluralize',
})
export class PluralizePipe implements PipeTransform {
  /**
   * Transforms a count into a formatted string with the appropriate singular or plural form.
   *
   * @param count - The numeric value to be displayed
   * @param singular - The singular form of the word (used when count === 1)
   * @param plural - Optional custom plural form. If not provided, defaults to singular + 's'
   *
   * @returns A formatted string containing the count followed by the appropriate word form
   *
   * @example
   * transform(1, 'company') // Returns "1 company"
   * transform(5, 'company') // Returns "5 companies"
   * transform(3, 'child', 'children') // Returns "3 children"
   * transform(1, 'child', 'children') // Returns "1 child"
   */
  transform(count: number, singular: string, plural?: string): string {
    const pluralForm = plural || `${singular}s`;
    return `${count} ${count === 1 ? singular : pluralForm}`;
  }
}
